// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3v-CQ","title":"Images90_title__vPkkQ","images":"Images90_images__3bky2"};